import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Poliza, Recibo, Riesgo } from '../../model/poliza.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolizaApiService extends BaseApiService{
  tarificarPoliza(poliza: Poliza<Riesgo>): Observable<Recibo> {
    return this.invocarSeguros<Recibo>('PUT', 'propuesta/simulacion', poliza);
  }

  contratarPoliza(poliza: Poliza<Riesgo>): Observable<Poliza<Riesgo>> {
    return this.invocarSeguros<Poliza<Riesgo>>('POST', 'poliza/contratar', poliza);
  }

  guardarPropuesta(poliza: Poliza<Riesgo>): Observable<Poliza<Riesgo>> {
    return this.invocarSeguros<Poliza<Riesgo>>('POST', 'propuesta', poliza);
  }

  recuperarPropuesta(codPropuesta: number): Observable<Poliza<Riesgo>> {
    return this.invocarSeguros<Poliza<Riesgo>>('GET', `propuesta/recuperar-proyecto/${codPropuesta}`);
  }

  imprimirPoliza(numeroPoliza: number, codProducto: number, codIdioma: string, esPropuesta:boolean ): Observable<string>{
    return this.invocarSeguros<string>('GET', `poliza/imprimir/${numeroPoliza}/${codProducto}/${codIdioma}/${esPropuesta}`);
  }

  permiteTarificarProtocoloUsuario(codProtocolo: number, codUsuario: string): Observable<boolean> {
    return this.invocarSeguros<boolean>('GET', `usuario/permite-tarificar-protocolo/${codProtocolo}/${codUsuario}`);
  }

  permiteRecuperarProyProtocoloUsuario(codProtocolo: number, codUsuario: string): Observable<boolean> {
    return this.invocarSeguros<boolean>('GET', `usuario/permite-recuperar-proyectos-protocolo/${codProtocolo}/${codUsuario}`);
  }

  permiteGuardarProyProtocoloUsuario(codProtocolo: number, codUsuario: string): Observable<boolean> {
    return this.invocarSeguros<boolean>('GET', `usuario/permite-guardar-proyectos-protocolo/${codProtocolo}/${codUsuario}`);
  }

  permiteContratarProtocoloUsuario(codProtocolo: number, codUsuario: string): Observable<boolean> {
    return this.invocarSeguros<boolean>('GET', `usuario/permite-contratar-protocolo/${codProtocolo}/${codUsuario}`);
  }
}
